<div class="main-container">

    <!-- FAD MASIVO DESTKOP -->
    <div class="barra-apps"
         *ngIf="isMobile === false  && isTablet === false  && this.router.url != '/firma-digital-gratis'">

        <div style="width: 100%; ">
            <p><a target="_blank" style="color: #5c5c5c; text-decoration: none;"
                  href="https://apps.apple.com/us/app/fad-firma-aut-c3-b3grafa-digital/id1295206858">Descargar FAD®
                <strong>para iOS </strong> <img
                        src="assets/images/ios_app.png" height="18" alt="iOs"></a><span style="color: #E3E3E3">..</span>|
                <a target="_blank" style="color: #5c5c5c; text-decoration: none;"
                   href="https://play.google.com/store/apps/details?id=com.na_at.fad"><span
                        style="color: #E3E3E3">..</span>Descargar FAD® <strong>para android </strong> <img
                        src="assets/images/android_app.png" height="18" alt="Android"></a><span style="color: #E3E3E3">..</span>|
                <a style="color: #5c5c5c; text-decoration: none;" href="https://clientes.firmaautografa.com/seleccion"
                   target="_blank"><span style="color: #E3E3E3">..</span>
                    <strong style="color: #A70534;">Visor</strong><strong style="margin-right: 20px;"> FAD®</strong></a>
            </p>
        </div>
    </div>

    <div class="header"
         *ngIf="isMobile === false  && isTablet === false  && this.router.url != '/firma-digital-gratis'">
        <div class="logo">
            <img src="assets/images/logo_header.png" alt="Logo" [routerLink]="['/']">
        </div>
        <div class="menu">
            <app-menu></app-menu>
        </div>
    </div>
    <div class="barra-apps-est"
         *ngIf="isMobile === false  && isTablet === false  && this.router.url == '/firma-digital-gratis'">
        <div style="width: 100%;">
            <p><a target="_blank" style="color: #5c5c5c; text-decoration: none; "
                  href="https://apps.apple.com/us/app/fad-firma-aut-c3-b3grafa-digital/id1295206858">Descargar FAD®
                <strong>para iOS </strong> <img
                        src="assets/images/ios_app.png" height="18" alt="iOs"></a><span style="color: #E3E3E3">..</span>|
                <a target="_blank" style="color: #5c5c5c; text-decoration: none;"
                   href="https://play.google.com/store/apps/details?id=com.na_at.fad"><span
                        style="color: #E3E3E3">..</span>Descargar FAD® <strong>para android </strong> <img
                        src="assets/images/android_app.png" height="18" alt="Android"></a><span style="color: #E3E3E3">..</span>|
                <a style="color: #5c5c5c; text-decoration: none;" href="https://clientes.firmaautografa.com/seleccion"
                   target="_blank"><span style="color: #E3E3E3">..</span>
                    <strong style="color: #A70534;">Visor</strong><strong style="margin-right: 20px;"> FAD®</strong></a>
            </p>
        </div>
    </div>
    <div class="header-est"
         *ngIf="isMobile === false  && isTablet === false && this.router.url == '/firma-digital-gratis'">
        <div class="logo-est">
            <img src="assets/images/logo_header.png" alt="Logo" [routerLink]="['/']">
        </div>
        <div class="menu">
            <app-menu></app-menu>
        </div>
    </div>

    <!-- FAD MASIVO MOVIL -->
    <div class="header-res" *ngIf="isMobile === true  || isTablet === true">
        <div class="logo">
            <img src="assets/images/logo_header.png" alt="Logo" [routerLink]="['/']">
        </div>
        <div class="menu">
            <app-menu></app-menu>
        </div>
    </div>

    <div class="content">

        <ng-content></ng-content>

        <!-- <div class="flotante" *ngIf="isMobile === false  && isTablet === false">
            <a target="_blank" id="flotante_whats"
               href="https://api.whatsapp.com/send?phone=5215527560645&text=Hola!%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20planes%20de%20FAD&utm_campaign=camp-ecommerce-latam&utm_source=ecommerce&utm_medium=WhatsApp">
                <img alt="Contáctanos" src="assets/images/m/whats-movil.png">
            </a>
        </div>

        <div class="flotante-m" id="flotante_whats_movil" *ngIf="isMobile === true  || isTablet === true">
            <a target="_blank"
               href="https://api.whatsapp.com/send?phone=5215527560645&text=Hola!%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20planes%20de%20FAD&utm_campaign=camp-ecommerce-latam&utm_source=ecommerce&utm_medium=WhatsApp">
                <img alt="Contáctanos" src="assets/images/m/whats-movil.png">
            </a>
        </div> -->

    </div>

    <!-- FAD MASIVO DESKTOP -->
    <div class="footer" *ngIf="isMobile === false  && isTablet === false">
        <div class="number">
            <div class="divider"></div>
            <p>Contacta con ventas:<br>
                <a id="contacto_ventas" href="mailto:hello@naat.tech" target="_blank"><img width="23px"
                                                                                                     src="assets/images/icon_mail_60x60.png"
                                                                                                     alt=""> hello@naat.tech</a>
                <br><a href="https://api.whatsapp.com/send?phone=5215527560645&text=Hola!%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20planes%20de%20FAD&utm_campaign=camp-ecommerce-latam&utm_source=ecommerce&utm_medium=WhatsApp"
                       target="_blank"><img width="23px" src="assets/images/whats.png" alt=""> 55 2756 0645</a>
            </p>
        </div>
        <div class="contain">
            <div class="logo">
                <img src="assets/images/logo_footer.png" alt="Logo" [routerLink]="['/']">
            </div>
            <div class="social-tags" style="margin-bottom: 40px;">
                <div class="social">
                    <p>Síguenos en:</p>
                    <div class="networks">
                        <img id="social_facebook" src="assets/images/icon_fb.png" alt="Facebook"
                             (click)="openLink('https://www.facebook.com/firmaautografadigital')">
                        <img id="social_linkedin" src="assets/images/icon_linkedin.png" alt="LinkedIn"
                             (click)="openLink('https://www.linkedin.com/company/firma-autografa-digital')">
                        <img id="social_youtube" src="assets/images/icon_youtube.png" alt="Youtube"
                             (click)="openLink('https://www.youtube.com/channel/UCywWB5Vj_cKK0OE9PuLG6sw')">
                    </div>
                    <div class="networks" style="margin-top: 20px;">
                        <img width="40px" src="assets/images/iso-27001-logo.png" alt="ISO 27001">
                        <img width="140px" src="assets/images/pci-logo.png" alt="PCI">
                    </div>
                </div>
                <div class="tags">
                    <p class="tag" [routerLink]="['/firma-digital-para-personas']">FAD® personal</p>
                    <p class="tag" [routerLink]="['/firma-digital-para-empresas']">FAD® empresa</p>
                    <p class="tag" [routerLink]="['/como-empezar-a-firmar-digitalmente']">Soporte</p>
                    <p class="tag" [routerLink]="['/preguntas-frecuentes-de-la-firma-digital-fad']">FAQs</p>
                </div>
            </div>
            <div class="applications">
                <p><span>Descarga FAD®</span> en tu móvil:</p>
                <div class="images">
                    <img id="descarga_google_play" src="assets/images/playstore.png" alt="Play Store"
                         (click)="openLink('https://play.google.com/store/apps/details?id=com.na_at.fad')">
                    <img id="descarga_app_store" src="assets/images/app_store.png" alt="App Store"
                         (click)="openLink('https://apps.apple.com/us/app/fad-firma-aut-c3-b3grafa-digital/id1295206858')">
                </div>
            </div>
        </div>
        <div class="footCopy">
            Toda la información contenida en este sitio es propiedad de MUUK Technologies, S. de R.L. de C.V. | <a
                target="_blank"
                href="https://trust.naat.tech/es/aviso-de-privacidad">Aviso de Privacidad</a> | <a
                routerLink="/terminos-y-condiciones">Términos y Condiciones</a> | <a
                routerLink="/politica-de-seguridad">Política de Seguridad de la Información</a>
        </div>
    </div>

    <!-- FAD MASIVO MOVIL -->
    <div class="footer-res" *ngIf="isMobile === true  || isTablet === true">
        <div class="number">
            <p>Contacta con ventas:<br><a id="contacto_ventas_movil" href="mailto:hello@naat.tech"
                                          target="_blank"><img width="23px" src="assets/images/icon_mail_60x60.png"
                                                               alt=""> hello@naat.tech</a>
                <br><a href="https://api.whatsapp.com/send?phone=5215527560645&text=Hola!%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20planes%20de%20FAD&utm_campaign=camp-ecommerce-latam&utm_source=ecommerce&utm_medium=WhatsApp"
                       target="_blank"><img width="23px" src="assets/images/whats.png" alt="">55 2756 0645</a>
            </p>
        </div>
        <div class="contain">
            <div class="applications">
                <p><span>Descarga FAD®</span> en tu móvil:</p>
                <div class="images">
                    <img id="descarga_google_play_movil" src="assets/images/playstore.png" alt="Play Store"
                         (click)="openLink('https://play.google.com/store/apps/details?id=com.na_at.fad')">
                    <img id="descarga_app_store_movil" src="assets/images/app_store.png" alt="App Store"
                         (click)="openLink('https://apps.apple.com/us/app/fad-firma-aut-c3-b3grafa-digital/id1295206858')">
                </div>
            </div>
            <div class="social-tags">
                <div class="tags">
                    <p class="tag" [routerLink]="['/firma-digital-para-personas']">FAD® personal</p>
                    <p class="tag-iz" [routerLink]="['/firma-digital-para-empresas']">FAD® empresa</p>
                    <p class="tag" [routerLink]="['/como-empezar-a-firmar-digitalmente']">Soporte</p>
                    <p class="tag-iz" [routerLink]="['/preguntas-frecuentes-de-la-firma-digital-fad']">FAQs</p>
                </div>
                <div class="social">
                    <p>Síguenos en:</p>
                    <div class="networks">
                        <img id="social_facebook_movil" src="assets/images/icon_fb.png" alt="Facebook"
                             (click)="openLink('https://www.facebook.com/firmaautografadigital')">
                        <img id="social_linkedin_movil" src="assets/images/icon_linkedin.png" alt="LinkedIn"
                             (click)="openLink('https://www.linkedin.com/company/firma-autografa-digital')">
                        <img id="social_youtube_movil" src="assets/images/icon_youtube.png" alt="Youtube"
                             (click)="openLink('https://www.youtube.com/channel/UCywWB5Vj_cKK0OE9PuLG6sw')">
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div class="logo">
                <img src="assets/images/logo_footer.png" alt="Logo" [routerLink]="['/']">
            </div>
            <div class="logo">
                <img src="assets/images/pci-logo.png" alt="PCI">
            </div>
            <div class="logo">
                <img src="assets/images/iso-27001-logo.png" alt="ISO 27001">
            </div>
        </div>
        <div class="footCopy">
            Toda la información contenida en este sitio es propiedad
            de MUUK Technologies, S. de R.L. de C.V. | <a target="_blank"
                                                          href="https://trust.naat.tech/es/aviso-de-privacidad">Aviso de
            Privacidad</a> | <a routerLink="/terminos-y-condiciones">Términos y Condiciones</a> | <a
                routerLink="/politica-de-seguridad">Política de Seguridad de la Información</a>
        </div>
    </div>
</div>
